import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system'

import colors from 'airship/design-system/theme/foundations/colors'

import typography from '../foundations/typography'

const baseStyle = defineStyle({
  color: colors.text.secondary,
  ...typography.textStyles.subheading.small,
})

const formLabelTheme = defineStyleConfig({
  baseStyle,
})

export default formLabelTheme
